export const RELEWISE = {
    datasetId: globalThis.relewiseDataSetId,
    datasetName: "Danish Agro A.M.B.A. - Free Trial",
    apiKey: globalThis.relewiseApiKey,
    serverUrl: globalThis.relewiseUrl,
};
